<template>
  <nav class="flex-1 text-gray-800 h-full overflow-y-scroll max-h-sidebar md:max-h-sidebar pb-8">
    <div class="pr-1">
      <div v-for="(p, index) in prices" :key="index" class="truncate mb-2">
        <router-link
          :to="{ name: 'price', params: { priceid: p.id } }"
        >{{ p.name }}</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SidebarNav',
  data() {
    return {
      showProjectNav: []
    };
  },
  computed: {
    ...mapGetters('prices', {
      prices: 'prices',
    })
  },
  methods: {
    toggleVisible: function(id) {
      let index = this.getIndex(id);
      if (index < 0) return;
      this.showProjectNav[index].visible = !this.showProjectNav[index].visible;
    },
    getVisible: function(id) {
      //if (this.showProjectNav.length == 0) return;
      let index = this.getIndex(id);
      if (index < 0) return;

      return this.showProjectNav[index].visible;
    },
    setVisible: function(id) {
      //if (this.showProjectNav.length == 0) return;

      let index = this.getIndex(id);
      if (index < 0) return;

      this.showProjectNav[index].visible = true;
    },
    getIndex: function(id) {
      let index = this.showProjectNav
        .map(function(e) {
          return e.id;
        })
        .indexOf(id);
      return index;
    },
    closeAll: function() {
      this.showProjectNav.forEach(function(nav) {
        nav.visible = false;
      });
    }
  },
  mounted() {
    this.closeAll();
    this.setVisible(this.$route.params.id);
  }
};
</script>
